
import { defineComponent } from "vue";
import AppButton from "@/common/components/AppButton.vue";

export default defineComponent({
  components: { AppButton },
});
